import { render } from "./VAccordionItemCategory.vue?vue&type=template&id=71425ead&scoped=true"
import script from "./VAccordionItemCategory.vue?vue&type=script&lang=js"
export * from "./VAccordionItemCategory.vue?vue&type=script&lang=js"

import "./VAccordionItemCategory.vue?vue&type=style&index=0&id=71425ead&scoped=true&lang=css"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71425ead"]])

export default __exports__